// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.black-color {
  color: #1A1A18;
}

.header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  padding: 10px 0px;
  background: transparent;
  height: calc(100% - 80px);
}
.header .icon_wrapper ion-icon {
  height: 10px;
  width: 10px;
  rotate: 180deg;
  transition: rotate 0.5s;
  margin-left: 10px;
}
.header .icon_wrapper ion-icon.isOpen {
  rotate: 0deg;
}

.title {
  cursor: pointer;
  position: relative;
  margin: 0;
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  line-height: 16px;
  text-align: left;
  text-transform: capitalize;
  color: var(--ion-color-secondary);
}

.name {
  font-family: AppFontBold, sans-serif;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.01em;
  color: var(--ion-color-secondary);
  text-align: left;
  padding: 15px 0px;
}

p {
  padding: 15px 0px;
  text-align: left;
  font-family: AppFont, sans-serif;
  font-size: 11.5px;
  line-height: 20px;
  letter-spacing: 0.01em;
  color: var(--ion-color-secondary) !important;
}

div {
  position: relative;
  transition: max-height linear 0.3s;
}
.active {
  max-height: -moz-fit-content;
  max-height: fit-content;
  overflow: auto;
  width: 100%;
  padding-top: 10px;
}

.inactive {
  max-height: 0;
  overflow: hidden;
}

.nutrition-name {
  font-size: 10px;
  text-align: left;
  color: var(--ion-color-secondary);
  padding-left: 20px;
}

.nutrition-value {
  text-align: right;
  color: var(--ion-color-secondary);
  font-size: 10px;
  padding-right: 20px;
}

.border-top {
  border-top: 1px solid #dcdddc;
}

.allergens_title {
  font-family: AppFont, sans-serif;
  font-size: 16px;
  color: var(--ion-color-black);
}

ul {
  margin: 0px;
  padding: 0px 30px;
}
ul li {
  font-size: 10px;
  text-align: left;
  color: var(--ion-color-secondary) !important;
  padding: 6px 0px;
}

.padding-top {
  padding-top: 15px;
}

.button {
  width: 100%;
  padding: 10px;
  margin-top: 20px;
}
.button .close {
  background: var(--ion-color-primary);
  width: 100%;
  height: 50px;
  text-align: center;
  border-radius: 50px;
}
.button .close span {
  text-align: center;
  font-size: 18px;
  font-family: AppFontBold, sans-serif;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/allergens-info-modal/allergens-info-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;AACF;AAKA;EACE,cAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;AAHF;AAKK;EACG,YAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;AAHR;AAIQ;EACG,YAAA;AAFX;;AAQA;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EAGA,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,0BAAA;EACA,iCAAA;AAPF;;AAUA;EACE,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iCAAA;EAEA,gBAAA;EACA,iBAAA;AARF;;AAWA;EACE,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,4CAAA;AARF;;AAWA;EACE,kBAAA;EACA,kCAAA;AARF;AAiBA;EACE,4BAAA;EAAA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;AAfF;;AAkBA;EACE,aAAA;EACA,gBAAA;AAfF;;AAiBA;EACE,eAAA;EACA,gBAAA;EACA,iCAAA;EAEA,kBAAA;AAfF;;AAiBA;EACE,iBAAA;EACA,iCAAA;EAEA,eAAA;EACA,mBAAA;AAfF;;AAiBA;EACE,6BAAA;AAdF;;AAgBA;EACE,gCAAA;EACA,eAAA;EACA,6BAAA;AAbF;;AAeA;EACE,WAAA;EAEA,iBAAA;AAbF;AAcE;EACG,eAAA;EACA,gBAAA;EACA,4CAAA;EAGA,gBAAA;AAdL;;AAiBA;EACE,iBAAA;AAdF;;AAgBA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AAbF;AAcE;EACE,oCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAZJ;AAaI;EACE,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,YAAA;AAXN","sourcesContent":[".container {\n  width: 100%;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  // background: #EAEAEB;\n  &.activated {\n     // background: white;\n  }\n}\n.black-color {\n  color: #1A1A18;\n\n}\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n  padding: 10px 0px;\n  background: transparent;\n  height: calc(100% - 80px);\n  .icon_wrapper {\n     ion-icon {\n        height: 10px;\n        width: 10px;\n        rotate: 180deg;\n        transition: rotate 0.5s;\n        margin-left: 10px;\n        &.isOpen{\n           rotate: 0deg;\n        }\n     }\n  }\n}\n\n.title {\n  cursor: pointer;\n  position: relative;\n  margin: 0;\n\n\n  font-family: AppFontBold, sans-serif;\n  font-size: 16px;\n  line-height: 16px;\n  text-align: left;\n  text-transform: capitalize;\n  color: var(--ion-color-secondary);\n}\n\n.name {\n  font-family: AppFontBold, sans-serif;\n  font-size: 12px;\n  line-height: 15px;\n  letter-spacing: 0.01em;\n  color: var(--ion-color-secondary);\n\n  text-align: left;\n  padding: 15px 0px;\n}\n\np {\n  padding: 15px 0px;\n  text-align: left;\n  font-family: AppFont, sans-serif;\n  font-size: 11.5px;\n  line-height: 20px;\n  letter-spacing: 0.01em;\n  color: var(--ion-color-secondary) !important;\n}\n\ndiv {\n  position: relative;\n  transition: max-height linear 0.3s;\n\n  ion-button {\n\n\n\n  }\n}\n\n.active {\n  max-height: fit-content;\n  overflow: auto;\n  width: 100%;\n  padding-top: 10px;\n}\n\n.inactive {\n  max-height: 0;\n  overflow: hidden;\n}\n.nutrition-name {\n  font-size: 10px;\n  text-align: left;\n  color: var(--ion-color-secondary);\n\n  padding-left: 20px;\n}\n.nutrition-value {\n  text-align: right;\n  color: var(--ion-color-secondary);\n\n  font-size: 10px;\n  padding-right: 20px;\n}\n.border-top {\n  border-top: 1px solid #dcdddc;\n}\n.allergens_title {\n  font-family: AppFont, sans-serif;\n  font-size: 16px;\n  color: var(--ion-color-black);\n}\nul {\n  margin: 0px;\n  // list-style-type: none;\n  padding: 0px 30px;\n  li {\n     font-size: 10px;\n     text-align: left;\n     color: var(--ion-color-secondary) !important;\n\n\n     padding: 6px 0px;\n  }\n}\n.padding-top {\n  padding-top: 15px;\n}\n.button {\n  width: 100%;\n  padding: 10px;\n  margin-top: 20px;\n  .close {\n    background: var(--ion-color-primary);\n    width: 100%;\n    height: 50px;\n    text-align: center;\n    border-radius: 50px;\n    span {\n      text-align: center;\n      font-size: 18px;\n      font-family: AppFontBold, sans-serif;\n      color: white;\n\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
